import { render, staticRenderFns } from "./AddUserForm.vue?vue&type=template&id=2fb46180&scoped=true"
import script from "./AddUserForm.vue?vue&type=script&lang=js"
export * from "./AddUserForm.vue?vue&type=script&lang=js"
import style0 from "./AddUserForm.vue?vue&type=style&index=0&id=2fb46180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb46180",
  null
  
)

export default component.exports